<template>
  <span id="pmlst-back">
    <button class="back" @click.prevent="onBackOutcome">
      <font-awesome-icon :i="icon" />
      {{ text }}
    </button>
  </span>
</template>

<script>
import FontAwesomeIcon from '@/components/FontAwesomeIcon'

export default {
  name: 'back-button',
  components: { FontAwesomeIcon },
  props: {
    back: {
      type: Object,
      default() {
        return {
          text: 'Back'
        }
      }
    }
  },
  computed: {
    icon() {
      let i = {}
      i.icon = this.$props.back.icon
        ? this.$props.back.icon
        : 'fa fa-angle-left'
      if (this.$props.back.color) {
        i.color = this.$props.back.color
      }
      return i
    },
    text() {
      return this.$props.back.text
    }
  },
  mounted() {
    this.$on('onBackOutcome', () => {
      this.$store.dispatch('backQuestionResponse')
    })
  },
  methods: {
    onBackOutcome() {
      this.$emit('onBackOutcome')
    }
  }
}
</script>
